import {
  BulkFlashLogActionNames,
  BulkFlashState,
  BulkFlashActionTypes,
  FlashTabStrings,
} from './types';

const initialState: BulkFlashState = {
  preFlashLogs: undefined,
  postFlashLogs: undefined,
  simCredentialingFile: undefined,
  simCredentialing: undefined,
  deviceCommands: undefined,
  errorFileDownloadIds: { preFlash: undefined, postFlash: undefined },
  batchId: undefined,
  totalAcceptedDevices: undefined,
  loading: false,
  logTab: FlashTabStrings.preFlash,
  manualDevicesToUpload: null,
  csvDevicesToUpload: null,
  preFlashFilters: {},
  modemFlashRecord: undefined,
  modemFlashFile: undefined,
};

export const bulkFlashReducer = (
  state: BulkFlashState = initialState,
  action: BulkFlashActionTypes,
): BulkFlashState => {
  switch (action.type) {
    case BulkFlashLogActionNames.SET_PRE_FLASH_LOG: {
      return {
        ...state,
        preFlashLogs: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_POST_FLASH_LOG: {
      return {
        ...state,
        postFlashLogs: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_SIM_CREDENTIALING_FILE: {
      return {
        ...state, 
        simCredentialingFile: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_SIM_CREDENTIALING: {
      return {
        ...state, 
        simCredentialing: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID: {
      return {
        ...state,
        errorFileDownloadIds: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_BATCH_ID: {
      return {
        ...state,
        batchId: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_TOTAL_ACCEPTED_DEVICES: {
      return {
        ...state,
        totalAcceptedDevices: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_LOG_TAB: {
      return {
        ...state,
        logTab: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_CSV_TO_UPLOAD: {
      return {
        ...state,
        csvDevicesToUpload: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_SELECTED_DEVICE: {
      return {
        ...state,
        manualDevicesToUpload: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_ACTIVE_FILTERS: {
      return {
        ...state,
        preFlashFilters: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_MODEM_FLASH_LOG: {
      return {
        ...state,
        modemFlashRecord: action.payload,
      };
    }
    case BulkFlashLogActionNames.SET_MODEM_FLASH_FILE:{
      return{
        ...state,
        modemFlashFile:action.payload,

      }
    }
    default:
      return state;
  }
};
